// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5915fddb","667":"f3fec74e","867":"af3dd691"}[chunkId] + ".chunk.js";
};